export enum PageSizeTables {
  AnnouncementTableCustom = 'announcement-table-custom',
  AnnouncementTableGlobal = 'announcement-table-global',
  AnswerGroupTable = 'answer-group-table',
  EndUserTable = 'end-user-table',
  EndUserSearchTable = 'end-user-search-table',
  MenuTable = 'menu-table',
  OrganizationSearchTable = 'organization-search-table',
  QueueStatisticsTable = 'queue-statistics-table',
  AgentStatisticsTable = 'agent-statistics-table',
  ServiceNumberSearchTable = 'agent-statistics-table'
}
